import {
  HeaderBalanceRule,
  investmentValueBalanceRule,
  LIST_HEADER_BALANCE_RULES,
  LIST_HEADER_CONFIG,
  LIST_HEADER_ICONS_CONFIG,
  mirrorBalanceRule,
  pettyCashBalanceRule,
} from '@celerofinancas/common-domain';

/**
 * Returns 'last_statement_balance' when the last statement date is available, otherwise returns null.
 */
export const localStatementBalanceRule: HeaderBalanceRule = (account) => {
  return account?.last_statement_at ? 'last_statement_balance' : null;
};

/**
 * Tokens related to the list header component configuration and rules.
 */
export const LIST_HEADER_TOKENS = [
  {
    provide: LIST_HEADER_BALANCE_RULES,
    useValue: [
      pettyCashBalanceRule,
      mirrorBalanceRule,
      investmentValueBalanceRule,
      localStatementBalanceRule,
    ],
  },
  {
    provide: LIST_HEADER_ICONS_CONFIG,
    useValue: {
      showEyeIcon: false,
      showConciliationError: false,
      showSeparator: false,
      textTitleTotalAccounts: 'Saldo Disponível | Contas Correntes',
      maxAccounts: 5,
      showInfoIcon: false,
      showEditIcon: false,
      showBloquedBalance: true,
      textModalListAccounts: 'Contas Correntes',
      textTooltipTotalAccounts:
        'Saldo disponível consolidado das suas contas Caixa e demais contas correntes conectadas via Open Finance.',
      disabledClickAccount: true,
    },
  },
  {
    provide: LIST_HEADER_CONFIG,
    useValue: {
      showBlockedBalance: false,
      showDisabledAccountsTooltip: false,
      showAccountNameTooltip: true,
      showAccountNumberTooltip: true,
      truncadeAccountNumber: true,
    },
  },
];
